module.exports = "<div id=\"app-loading\">\r\n  <div class=\"loader running\">\r\n  </div>\r\n</div>\r\n"